import * as interventionActionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isSending = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [interventionActionTypes.POST_SEND_BY_REQUEST]: isSending,
  [interventionActionTypes.POST_SEND_BY_SUCCESS]: isEnding,
  [interventionActionTypes.POST_SEND_BY_FAILURE]: isEnding,
});
